<template>
  <StepTimeline
    :legi-work-ref="legiWorkZoom.ref"
    :clickable="true"
    :timeline="legiWorkZoom.timeline"
  />

  <RouterView />
</template>

<script setup>
import { storeToRefs } from "pinia";
import StepTimeline from "../atoms/StepTimeline.vue";
import { useLegiWorkStore } from "@follaw-fr/stores/legi-work";
import { RouterView } from "vue-router";
import { getTimelineUrl } from "@/follaw-fr/utils/legidoc-timeline-routing";
import { useRouter } from "vue-router";
import { useRouteParams } from "@vueuse/router";

const router = useRouter();
const store = useLegiWorkStore();
const { legiWorkZoom } = storeToRefs(store);

// TODO refactor this in a composable and place it in a onBeforeRouteUpdate()
const stepIdx = useRouteParams("stepIdx");

if (!stepIdx.value) {
  // Redirect to last version of the text
  const newUrl = getTimelineUrl(
    `/legislatives/${store.legiWorkZoom.ref}/timeline`,
    store.legiWorkZoom.timeline,
    store.legiWorkZoom.timeline.length - 1
  );

  router.replace(newUrl);
}
</script>
